module.exports = __webpack_public_path__ + "static/media/quotearrow.d8b22a6f.svg";